module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight register"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInUp",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/logos/lcp-logo.svg"),
      "width": "312",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.showFlashMessage) ? _c('MessageBox', {
    staticStyle: {
      "padding": "0 15px"
    },
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-text', [_c('InitialRegistration')], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "testimonial"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/testimonial-reg.png"),
      "alt": "Liz Before and After"
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "testimonial-block"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/quote.svg"),
      "width": "28",
      "alt": "Quote Icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-text"
  }, [_c('p', [_vm._v("“I’m a vegetarian and lost 13kg (2st) and am in Type 2 Diabetes Remission”")])]), _vm._v(" "), _c('div', {
    staticClass: "testimonial-from"
  }, [_c('p', [_vm._v("Liz")]), _vm._v(" "), _c('p', {
    staticClass: "member"
  }, [_vm._v("Member since 2019")])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ecbd12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register/Register.vue
// module id = 3176
// module chunks = 1